import { render, staticRenderFns } from "./ModifyTaskDueDates.vue?vue&type=template&id=7a827cb1&scoped=true&"
import script from "./ModifyTaskDueDates.vue?vue&type=script&lang=js&"
export * from "./ModifyTaskDueDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a827cb1",
  null
  
)

export default component.exports